import React from 'react';
import { connect } from 'react-redux';
import { Spin, message, Popover, Icon, Modal, Tooltip } from 'antd';
import TableC from '../basicElement/TableC';
import API_URL from '../../common/url';
import $ from '../../common/AjaxRequest';
import Filter from './Filter';
import PreviewModal from './ViewInfoProcess';
import SetRoleUsers from './SetRoleUsers';
import SetPA from './SetPA';
import RoleSelectionModal from './RoleSelectionModal';
import CreateModal from './CreateModal';
import ConfigColumn from './ConfigColumn';
import Simple from './Simple';
import { saveJdeCode, saveParams } from '../../actions/investigationActions';
import cf from '../../utils/cf';
import fp from '../../utils/fp';

const GlobalTypeList = [
    { label: '全球多中心', value: 'Global_Multicenter' },
    { label: '国内多中心', value: 'Internal_Multicenter' },
    { label: '国内单中心管理(区域负责)', value: 'Internal_Single' },
    { label: '不适用', value: 'Not_Applicable' },
];
const MedicineTypeList = [
    {value: 'Research_drugs', label: '药物'},
    {
        value: 'Technology', 
        label: '技术类',
        children: [
            {
                value: 'Radiation_therapy', 
                label: '放射疗法（同位素 核药；照射）',
            },
            {
                value: 'Cell_therapy', 
                label: '细胞治疗: CART',
            },
            {
                value: 'Stem_cell_therapy', 
                label: '干细胞治疗',
            },
            {
                value: 'Organ_transplant', 
                label: '器官移植',
            },
            {
                value: 'Gene_therapy', 
                label: '基因治疗',
            },
            {
                value: 'Dialysis', 
                label: '透析',
            },
        ]
    },
    {value: 'Medical_instruments', label: '医疗器械'},
    {value: 'Vaccines', label: '疫苗'},
    {value: 'Diagnostic_reagent', label: '诊断试剂'},
    {value: 'Others', label: '其他'},
]
const Tip = (
    <Tooltip overlayClassName="downloadSite" placement="top" title="已启动中心数/津石计划负责中心数量">
        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
    </Tooltip>
);
const defaultPagination = {
    pageSize: 10,
    current: 1,
    showTotal: (total, range) => (<span style={{ color: "#108ee9" }}>总计{total}条记录，每页10条</span>)
};
const defaultSearchParams = {
    sitePlanSymbol: 'NotLess',
    conAmountSymbol: 'NotLess',
};

class InvestigationList extends React.Component {
    constructor(props) {
        super(props);
        const { match, feedBack, current: propCurrent, pagination: propPagination, searchParams: propSearchParams } = props;
        const current = feedBack ? propCurrent : '1';
        const pagination = Object.assign({}, defaultPagination, feedBack && propPagination);
        const searchParams = Object.assign({}, defaultSearchParams, feedBack && propSearchParams);
        this.invId = match ? match.params.invId : '';
        this.state = {
            current,
            pagination,
            searchParams,
            sortParams: {},
            data: [],
            planList: [],
            tableHeader: [],
            isSimple: undefined,
            loading: false,
            createVisible: false,
            chooseType: "projectList",
            areaList: [],
            typeList: [],
            levelList: [],
            invStatusList: [],
            stageList: [],
            businessList: [],
            testeeTypeList: [],
            contractTypeList: [],
        };
    }

    componentDidMount() {
        // 修复浏览器返的bug
        const { positionRole } = sessionStorage;
        sessionStorage.curRole = positionRole;

        this.queryMode();
        this.queryWithLevelByParams('LINE_OF_BUSINESS');
        this.loadTypeConfigureList();

        const { current = '1' } = this.props;
        this.setState({current: current});
        this.props.saveParams({ current: current, pagination: {}, searchParams: {} });
    }

    // 查询简洁模式
    queryMode = () => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryUserInvestigationListById,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const { isSimple } = data || {};
                this.setState({ isSimple: isSimple === undefined || isSimple === '1' }, () => {
                    !this.state.isSimple && this.getHeader();
                });
            }
        };
        $.sendRequest(options);
    }

    setMode = () => {
        const { isSimple } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.saveUserInvestigationList,
            data: { isSimple: isSimple ? 0 : 1 },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                const { pagination } = this.state;
                pagination.current = 1;
                this.setState({
                    pagination,
                    loading: false,
                    sortParams: {},
                    isSimple: !isSimple,
                }, () => {
                    !this.state.isSimple && this.getHeader();
                });
            }
        };
        $.sendRequest(options);
    }

    loadTypeConfigureList = () => {
        const options = {
            method: 'POST',
            url: API_URL.common.typeConfigureList,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    areaList: res.areaList,
                    levelList: res.levelList,
                    invStatusList: res.invStatusList || [],
                    typeList: res.typeList,
                    stageList: res.stageList,
                    testeeTypeList: res.testeeTypeList,
                    contractTypeList: res.contractTypeList,
                });
            }
        }
        $.sendRequest(options)
    }

    getHeader = () => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.getheader,
            data: { startedInvestigation: 1 },
            dataType: 'json',
            doneResult: data => {
                const { headers = [] } = data.data;
                const tableHeader = [];
                headers.forEach(head => {
                    if (head.isShow !== "0") {
                        tableHeader.push(head);
                    }
                });
                this.setState({ tableHeader }, () => {
                    this.loadNormalData();
                });
            }
        };
        $.sendRequest(options);
    }

    loadNormalData = () => {
        const { sortParams, searchParams, pagination, pagination: { current, pageSize } } = this.state;
        const {investigationMedicineType = []} = searchParams;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.list,
            data: {
                offset: current,
                limit: pageSize,
                startedInvestigation: 1,
                ...sortParams,
                ...searchParams,
                manageFlag: 0,
                searchInvId: this.invId,
                investigationMedicineType: investigationMedicineType[0],
                secondResearchProductType: investigationMedicineType[1],
            },
            dataType: 'json',
            doneResult: res => {
                const { investigations = {} } = res.data;
                const { datas, totalCount } = investigations;
                pagination.total = totalCount;
                this.invId = '';
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            }
        };
        $.sendRequest(options);
    }

    loadData = () => {
        const { isSimple } = this.state;
        if (isSimple) {
            this.setState({ load: {} });
        } else {
            this.loadNormalData();
        }
    }

    queryWithLevelByParams = (typeName) => {
        const options = {
            method: 'POST',
            url: API_URL.common.queryWithLevelByParams,
            data: { typeName },
            dataType: 'json',
            doneResult: res => {
                const { typeConfigureList } = res;
                this.setState({ businessList: typeConfigureList || [] });
            },
        };
        $.sendRequest(options);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams: {...searchParams} });
    }

    reset = () => {
        this.props.saveParams({ current: '1', pagination: {}, searchParams: {} });
        this.setState({
            searchParams: { ...defaultSearchParams },
        }, () => {
            this.search();
        });
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    del = investigationId => {
        Modal.confirm({
            iconType: 'question-circle',
            title: "确认要删除该项目？",
            onOk: () => {
                const options = {
                    method: 'POST',
                    url: API_URL.investigation.del,
                    data: {
                        investigationId,
                    },
                    dataType: 'json',
                    doneResult: () => {
                        message.success('删除成功');
                        this.loadData();
                    }
                };
                $.sendRequest(options);
            },
        });
    }

    canEditByInvStatus = (investigationId, callback) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const canEdit = !(data || []).some(i => {
                    if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                        message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                        return true;
                    } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                        message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                        return true;
                    } else if (i.operation === 'TERMINATED_BEFORE_CONTRACT') {
                        message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                        return true;
                    } else if (i.operation === 'BUSINESS_DATA_ARCHIVING') {
                        message.error('项目到达“业务数据归档”阶段，不可编辑项目相关数据');
                        return true;
                    }
                    return false;
                });
                this.setState({ loading: false }, () => {
                    if (canEdit) {
                        callback();
                    }
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    canEditDelegateUserByInvStatus = (investigationId, callback) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const canEdit = !(data || []).some(i => {
                    if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                        message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                        return true;
                    } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                        message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                        return true;
                    } else if (i.operation === 'TERMINATED_BEFORE_CONTRACT') {
                        message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                        return true;
                    }
                    return false;
                });
                this.setState({ loading: false }, () => {
                    if (canEdit) {
                        callback();
                    }
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const columns = [];
        const { userId, curRole } = sessionStorage;
        const { tableHeader } = this.state;
        columns.push({
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 60,
        }, {
            title: '项目识别码',
            dataIndex: 'identifyCode',
            key: 'identifyCode',
            fixed: 'left',
            width: 120,
            render: (text, record) => {
                const { investigationIdentifyCode } = record;
                return investigationIdentifyCode
            },
        },{
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            fixed: 'left',
            width: 180,
            sorter: true,
            sortType: 'COMMON',
            render: (text, record) => {
                const { allowEnter, investigationId } = record;
                return (
                    <span>
                        {
                            allowEnter ?
                                <a onClick={() => this.selectInvestigation(investigationId)}>{text}</a>
                            :
                                text
                        }
                    </span>
                );
            },
        })
        tableHeader.forEach(d => {
            if (d.field != 'investigationName') {
                const params = {
                    title: d.displayName,
                    dataIndex: d.field,
                    key: d.field,
                    sorter: d.type == 'ROLE' ? false : d.sortable,
                    sortType: d.type,
                    width: tableHeader.length > 4 ? 180 : "auto",
                };
                if (d.field == 'administrationModeShow') {
                    params.render = (text, row, index) => {
                        let remarkDom = null;
                        if (row.administrationModeRemark) {
                            remarkDom = (
                                <Popover placement="top" content={row.administrationModeRemark} trigger="hover">
                                    <i className="pop nopop"></i>
                                </Popover>
                            )
                        }
                        return (
                            <span>
                                {remarkDom}
                                {text}
                            </span>
                        )
                    };
                } else if (d.field == 'investigationJdeContractCode') {
                    params.render = (text, row, index) => {
                        const { investigationJdeContractCode, pmIds } = row;
                        return (
                            (curRole == 'BO' || (curRole == 'PM' && (pmIds || '').indexOf(userId) >= 0)) ?
                                <a onClick={() => this.saveJdeCode(investigationJdeContractCode)}>{text}</a>
                            :
                                text
                        )
                    };
                } else if (d.field === 'siteStartStateName') {
                    params.title = (
                        <span>
                            {d.displayName} {Tip}
                        </span>
                    );
                }
                columns.push(params);
            }
        })

        const splitString = fp.compose(
            fp.split(','),
            fp.defValue('')
        );

        columns.push({
            title: <div className="config_clm_oper"><span>操作</span><Icon onClick={() => this.configColumn()} type="setting" style={{ float: "right", fontSize: "18px", marginRight: "10px" }} /></div>,
            dataIndex: 'operation',
            key: 'operation',
            width: 140,
            fixed: 'right',
            render: (text, record) => {
                const { userId, isInvPM } = sessionStorage
                const { pmUserIds, paAndPmIds, paIds, pmIds, investigationId } = record;
                const configPA = fp.compose(
                    fp.contains(userId),
                    splitString
                )(pmUserIds);
                const paAndPmIdsArr = splitString(paAndPmIds);
                const delegateUser = paIds || pmIds;
                const paIdsArr = splitString(paIds);
                const pmIdsArr = splitString(pmIds);
                const isPAorPM = paAndPmIdsArr.includes(userId);
                const role = pmIdsArr.includes(userId) ? "PM" : paIdsArr.includes(userId) ? "PA" : "";
                const operationCorrespondRoles = new Map([
                    ['infoProcess', {
                        name: '项目信息和进展',
                        display: true,
                        editable: true,
                        event: () => this.showPreviewModal(investigationId),
                        roles: ['*'],
                    }],
                    ['confPro', {
                        name: '配置项目',
                        display: fp.contains(curRole, ['BO', 'CTA', 'PML']) || isPAorPM,
                        editable: true,
                        event: () => this.canEditByInvStatus(investigationId, () => this.toConfigInv(record, isPAorPM ? role : curRole)),
                        roles: ['*'],
                    }],
                    ['delegateUser', {
                        name: !delegateUser ? '委派人员' : '变更人员',
                        display: true,
                        editable: true,
                        event: () => this.canEditDelegateUserByInvStatus(investigationId, () => this.delegateUser(investigationId, delegateUser)),
                        roles: ['BO', 'CTA'],
                    }],
                    ['delete', {
                        name: '删除',
                        display: true,
                        editable: true,
                        event: () => this.del(investigationId),
                        roles: ['CTA'],
                    }],
                    ['configPA', {
                        name: '配置PA和协助项目成员',
                        display: fp.contains(curRole, ['PML']) || configPA,
                        editable: true,
                        event: () => this.canEditByInvStatus(investigationId, () => this.setPA(investigationId, 'PA')),
                        roles: ['PA', 'PM', 'CRC', 'CRCC', 'CRCM', 'BD', 'BDO', 'BDM', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA'],
                    }],
                    ['configBD', {
                        name: '配置BD',
                        display: true,
                        editable: true,
                        event: () => this.canEditByInvStatus(investigationId, () => this.setPA(investigationId, 'BD')),
                        roles: ['BDM'],
                    }],
                ]);
                return (
                    <span>
                        {   fp.compose(
                                fp.curry(cf.operationAuthByRole)(index => <span key={index} className="ant-divider" />),
                                fp.filter(i => !!i),
                                // 获取角色对应操作
                                fp.curry(cf.authDomList)(operationCorrespondRoles)
                            )(curRole)
                        }
                    </span>
                );
            }
        });
        return columns;
    }

    getDataSource = () => {
        const { data, tableHeader } = this.state;

        let headers = tableHeader; //从获取表头接口获取到的表头列表
        let invList = data; //从数据接口获取到的项目列表
        let dataSource = []; //数据源

        invList.map((inv, i) => {
            //遍历项目列表inv为项目
            let row = {
                investigationId: inv.investigationId,
                investigationName: inv.investigationName,
                investigationIdentifyCode: inv.investigationIdentifyCode,
                allowEnter: inv.allowEnter, isShowProcess: inv.isShowProcess,
                paAndPmIds: inv.paAndPmIds,
                paIds: inv.paIds,
                pmIds: inv.pmIds,
            }; //数据源的一行

            headers.map((header, j) => {
                //遍历表头列表， header为某一表头
                let field = header.field;
                let value; //对应值
                inv.fields.map((invField, k) => {
                    //遍历项目中的字段列表
                    if (invField.field == header.field) {
                        value = invField.value;
                    }
                });
                // 把字段值添加到数据源行
                if (field == 'investigationName') {
                    row.invName = value;
                }
                if (field == 'investigationSpecialName') {
                    row.invSpecialName = value;
                }
                if(field == 'invStatus'){
                    value = inv.fields.find(f => f.field == 'invStatusShow').value;
                }
                row[field] = <span style={{ whiteSpace: 'pre-wrap' }}>{value}</span>;
                if (field == 'investigationJdeContractCode') {
                    row[field] = value;
                }
            });

            inv.fields.map((invField, k) => {
                //遍历项目中的字段列表
                if (invField.field == "pmUserIds") {
                    row["pmUserIds"] = invField.value;
                } else if (invField.field == 'administrationModeRemark') {
                    row["administrationModeRemark"] = invField.value;
                }
            });

            //把数据源行添加到数据源
            dataSource.push(row);
        });
        return dataSource;
    }

    selectInvestigation = (investigationId) => {
        const { data } = this.state;
        const investigation = (data || []).find(i => i.investigationId == investigationId) || {};
        const { curRole } = sessionStorage;
        if (curRole == 'VP' || curRole == 'FIN') {
            this.selectRole(curRole, curRole, investigation);
        } else {
            this.getRoleListForInvestigation(investigation);
        }
    }

    roleNames = {
        CTA: 'smoCTA',
        VP: '副总裁',
        FIN: '财务',
        BO: '总监',
        BDO: 'BD总监',
        TAL: '领域leader',
        BDM: 'BDM',
        BD: 'BD',
        BA: 'BA',
        BAL: 'BAL',
        PA: '项目管理员',
        PM: '项目经理',
        CRCM: 'CRC经理',
        CRCC: 'CRC主管',
        CRC: '临床协调员',
        PML: 'PML',
        CSA: 'CSA',
        CSAL: 'CSAL',
        KAM: '大客户经理',
    }

    selectRole = (role, roles, investigation) => {
        const newRole = role === 'KAM' ? 'TAL' : role;
        const isKeyAccountManager = role === 'KAM' ? true : false;
        const newRoles = typeof(roles) === 'string' ? roles : roles.map(el => el === 'KAM' ? 'TAL': el);
        const { isSimple, current, pagination, searchParams } = this.state;
        const { fields, status, completeTime, investigationId, investigationName, investigationSpecialName } = investigation;
        sessionStorage.isKeyAccountManager = isKeyAccountManager;
        sessionStorage.roles = newRoles;
        sessionStorage.invStatus = status;
        sessionStorage.completeTime = completeTime;
        if (isSimple) {
            sessionStorage.invName = investigationName;
            sessionStorage.invSpecialName = investigationSpecialName;
        } else {
            (fields || []).forEach(i => {
                if (i.field == 'investigationName') {
                    sessionStorage.invName = i.value;
                }
                if (i.field == 'investigationSpecialName') {
                    sessionStorage.invSpecialName = i.value;
                }
            });
        }
        location.href = `./#/siteList/` + newRole + '/' + investigationId;
        // 在切换url前dispatch会整体更新，导致Header中会清除项目状态。
        this.props.saveParams({ current, pagination, searchParams });
    }

    getRoleListForInvestigation = (investigation) => {
        const options = {
            method: 'POST',
            url: API_URL.user.getRoleListForInvestigation,
            data: { investigationId: investigation.investigationId },
            dataType: 'json',
            doneResult: data => {
                const { roles } = data.data;
                const { curRole } = sessionStorage;
                if (roles.length > 1) {
                    this.selectUserRoleOption(roles, investigation);
                } else if (roles.length == 1) {
                    this.selectRole(roles[0], roles, investigation);
                } else if (curRole == 'CRCC' || curRole == 'CRCM' ) {
                    this.selectRole(curRole, [curRole], investigation);
                } else {
                    message.warning('该人员在项目上没有分配角色！');
                }
            },
        };
        $.sendRequest(options);
    }

    selectUserRoleOption = (roles, investigation) => {
        this.roleSelectionModelRef.show(roles, investigation);
    }

    showPreviewModal = investigationId => {
        this.previewModalRef.show(investigationId);
    }

    showCreate = createVisible => {
        this.setState({ createVisible });
    }

    configColumn = () => {
        this.configColumnRef.show();
    }

    delegateUser = (investigationId, change) => {
        this.delegateUserRef.show(investigationId, change);
    }

    setPA = (investigationId, curRole) => {
        this.setPARef.show(investigationId, curRole);
    }

    toConfigInv = (record, role) => {
        const { isSimple, current, pagination, searchParams } = this.state;
        sessionStorage.invId = record.investigationId;
        sessionStorage.curRole = (role == 'BO' || role == 'PML') ? 'PM' : role;
        sessionStorage.invName = !isSimple ? record.invName : record.investigationName;
        sessionStorage.invSpecialName = !isSimple ? record.invSpecialName : record.investigationSpecialName;
        this.props.saveParams({
            current,
            feedBack: true,
            pagination,
            searchParams,
        });
        location.href = `./#/invDetails`;
    }

    changeType = (chooseType) => {
        this.setState({ chooseType });
        if (chooseType == "projectPercent") {
            location.href = `./#/proPercent`;
        } else if (chooseType == "projectList") {
            location.href = `./#/invList`;
        }
    }

    saveJdeCode = (investigationJdeContractCode) => {
        this.props.saveJdeCode(investigationJdeContractCode);
        location.href = `./#/proPercent`;
    }

    handleTabsChange = (current) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            current,
            pagination,
            sortParams: {},
        });
    }

    handleTableChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    render() {
        const {
            isSimple,
            loading,
            current,
            pagination,
            tableHeader,
            chooseType,
            createVisible,
            areaList,
            typeList,
            levelList,
            invStatusList,
            stageList,
            businessList,
            testeeTypeList,
            contractTypeList,
            sortParams,
            searchParams,
            load = null,
        } = this.state;
        const yScroll = (tableHeader.length * 180 + 205) > 955 ? document.documentElement.clientHeight - 190 : false;
        const { curRole } = sessionStorage;
        //自定义显示列勾选少于2时，tableHeader.length<4 特殊处理

        const settings = {
            areaList,
            typeList,
            levelList,
            invStatusList,
            stageList,
            businessList,
            testeeTypeList,
            contractTypeList,
            GlobalTypeList,
            MedicineTypeList,
        };
        return (
            <div className="full home">
                {
                    (curRole == 'BO' || curRole == 'PM' || curRole == 'VP' || curRole == 'FIN' || curRole == 'PML') &&
                    <div className='change-btn' style={{ marginBottom: 30 }}>
                        <a className={chooseType == "projectList" ? 'cur' : ''} onClick={() => { this.changeType('projectList') }} >项目列表</a>
                        <a className={chooseType == "projectPercent" ? 'cur' : ''} onClick={() => { this.changeType('projectPercent') }} >项目完工百分比汇总</a>
                    </div>
                }
                <div>
                    <Filter
                        {...settings}
                        isSimple={isSimple}
                        reset={this.reset}
                        search={this.search}
                        setMode={this.setMode}
                        searchParams={searchParams}
                        showCreate={this.showCreate}
                        onChange={this.handleFilterChange}
                    />
                    <Spin spinning={loading}>
                        {
                            isSimple === true &&
                            <Simple
                                load={load}
                                activeKey={current}
                                pagination={pagination}
                                sortParams={sortParams}
                                searchParams={searchParams}
                                del={this.del}
                                setPA={this.setPA}
                                toConfigInv={this.toConfigInv}
                                saveJdeCode={this.saveJdeCode}
                                delegateUser={this.delegateUser}
                                handleTabsChange={this.handleTabsChange}
                                handleTableChange={this.handleTableChange}
                                showPreviewModal={this.showPreviewModal}
                                canEditByInvStatus={this.canEditByInvStatus}
                                canEditDelegateUserByInvStatus={this.canEditDelegateUserByInvStatus}
                                selectRole={this.selectRole}
                                getRoleListForInvestigation={this.getRoleListForInvestigation}
                            />
                        }
                        {
                            isSimple === false &&
                            <TableC
                                columns={this.getColumns()}
                                data={this.getDataSource()}
                                rowKey="investigationId"
                                scrollY={yScroll}
                                onChange={this.handleTableChange}
                                pagination={pagination}
                                sortParams={sortParams}
                                className="normalInvestigationList"
                            />
                        }
                    </Spin>
                </div>
                <PreviewModal isModal={true} loadData={this.loadData} ref={el => this.previewModalRef = el} />
                <SetRoleUsers ref={el => this.delegateUserRef = el} />
                <RoleSelectionModal ref={el => this.roleSelectionModelRef = el} selectRole={this.selectRole} />
                <SetPA ref={el => this.setPARef = el} />
                <CreateModal
                    loadData={this.loadData}
                    visible={createVisible}
                    showCreate={this.showCreate}
                    {...settings}
                />
                <ConfigColumn
                    ref={el => this.configColumnRef = el}
                    getHeader={this.getHeader}
                />
            </div>
        );
    }
}

const mapSateToProps = (state) => ({
    current: state.investigationState.current,
    feedBack: state.investigationState.feedBack || false,
    pagination: state.investigationState.pagination || {},
    searchParams: state.investigationState.searchParams || {},
});

const mapDispatchToProps = (dispatch) => ({
    saveJdeCode: (jdeCode) => dispatch(saveJdeCode(jdeCode)),
    saveParams: (params) => dispatch(saveParams(params)),
});

export default connect(mapSateToProps, mapDispatchToProps)(InvestigationList);


// WEBPACK FOOTER //
// ./src/components/investigation/InvestigationList.js